<div class="container">
	<app-action-button
		(buttonClicked)="onClick()"
		[title]="btnLabel"
		[customStyle]="customStyle"
		class="confirm-button"
		[disabled]="disabled"
		*ngIf="!showPopup"
	></app-action-button>

	<div
		class="popup"
		*ngIf="showPopup"
	>
    <app-action-button
      #confirmBtn
      cdkFocusInitial
			(buttonClicked)="onConfirm()"
			[title]="'confirm ' + btnLabel"
			[customStyle]="confirmBtnStyle"
		></app-action-button>
	</div>
</div>
